module.exports = __webpack_public_path__ + "img/vpn-5.ddba45aa.webp";